import { render, staticRenderFns } from "./KCheckbox.vue?vue&type=template&id=6558f333&scoped=true&"
import script from "./KCheckbox.vue?vue&type=script&lang=js&"
export * from "./KCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6558f333",
  null
  
)

export default component.exports